export default __webpack_public_path__ + "static/media/lines.d1c672e5.png";